import { render, staticRenderFns } from "./DocumentTableNew.vue?vue&type=template&id=2a06fbd4&scoped=true"
import script from "./DocumentTableNew.vue?vue&type=script&lang=ts"
export * from "./DocumentTableNew.vue?vue&type=script&lang=ts"
import style0 from "./DocumentTableNew.vue?vue&type=style&index=0&id=2a06fbd4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a06fbd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a06fbd4')) {
      api.createRecord('2a06fbd4', component.options)
    } else {
      api.reload('2a06fbd4', component.options)
    }
    module.hot.accept("./DocumentTableNew.vue?vue&type=template&id=2a06fbd4&scoped=true", function () {
      api.rerender('2a06fbd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documents/DocumentTableNew.vue"
export default component.exports